import React from 'react';
import './footer.css';
import { FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container1">
                <h3>STAY UP TO DATE WITH OUR NEWS AND NOTIFICATIONS</h3>
                <div className="social-link1">
                    <a href="https://www.instagram.com/upes_ozone/" target="_blank" rel="noopener noreferrer">
                        <FaInstagram color="white" />
                    </a>
                    <a href="https://www.linkedin.com/in/ozone-student-society-660836290/" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin color="white" />
                    </a>
                </div>
                <div className="copyright">
                    &copy; {new Date().getFullYear()} UPES-OZONE | ALL RIGHTS RESERVED
                </div>
            </div>
        </footer>
    );
};

export default Footer;
